import { render, staticRenderFns } from "./team-size-calculator.vue?vue&type=template&id=0172ceaa"
import script from "./team-size-calculator.vue?vue&type=script&lang=js"
export * from "./team-size-calculator.vue?vue&type=script&lang=js"
import style0 from "./team-size-calculator.vue?vue&type=style&index=0&id=0172ceaa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports